import tns from 'tinyslider';

export default class ContentCards {

    constructor(root) {
        this.container = root;

        this.cardsSlider = this.container.querySelector('.slider');
        this.dotsContainer = this.container.querySelector('.dots-container');

        this.slider = tns({
            container: this.cardsSlider,
            items: 1,
            slideBy: 1,
            center: false,
            loop: false,
            autoWidth: true,
            mouseDrag: true,
            gutter: 10,
            controls: false,
            navContainer: this.dotsContainer,
            disable: false,
            onInit: () => {this.equalizeCardHeights()},
            responsive: {
                768: {
                    items: 3,
                },
                1200: {
                    disable: true
                },
                1489: {
                    autoWidth: true,
                    center: false
                }
            }
        });

        this.slider.events.on('newBreakpointStart', () => {this.equalizeCardHeights();});
    }

    equalizeCardHeights() {
        let max = 0;
        this.container.querySelectorAll('.card').forEach(card => {
            card.style.height = 'auto';
            if(card.getBoundingClientRect().height > max) {
                max = card.getBoundingClientRect().height;
            }
        });

        this.container.querySelectorAll('.card').forEach(card => {
            card.style.height = `${max}px`;
        });
    }
}